import { Link } from 'react-router-dom'
import { SEO } from '@/components/seo'
import { Button } from '@/components/ui'

// Feature data
const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
      </svg>
    ),
    title: 'AI Report Writing',
    description: 'Tell the AI what you discussed. It researches products, writes the suitability report, and cites its sources. You review and approve.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
      </svg>
    ),
    title: 'Automated Research',
    description: 'Product comparisons, fund analysis, and provider research done for you. Always current, always referenced.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
    title: 'Built-In Compliance',
    description: "FCA rules checked automatically. COBS and PROD requirements flagged before you submit. Your compliance officer will be suspiciously quiet.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg>
    ),
    title: 'Your Templates, Your Way',
    description: "Customise report sections, adjust tone of voice, and save your firm's templates. The AI learns your style.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
      </svg>
    ),
    title: 'Bank-Grade Security',
    description: "End-to-end encryption, UK data centres, and regular penetration testing. Your clients' data stays yours.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: 'Minutes, Not Hours',
    description: 'Draft a comprehensive suitability report in under 10 minutes. Spend your time advising, not typing.',
  },
]

// Feature areas for explorer
const featureAreas = [
  {
    id: 'reports',
    title: 'AI Reports',
    subtitle: 'Sparks AI',
    description: 'Suitability reports, file notes, and client correspondence generated by AI with full compliance checking.',
    color: 'teal',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#0a0d12" strokeWidth="2" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
      </svg>
    ),
  },
  {
    id: 'meetings',
    title: 'Meetings',
    subtitle: 'Capture & Transcribe',
    description: 'Record client meetings, get AI transcriptions, and automatically generate file notes.',
    color: 'purple',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#0a0d12" strokeWidth="2" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
      </svg>
    ),
  },
  {
    id: 'compliance',
    title: 'Compliance',
    subtitle: 'FCA COBS Checking',
    description: 'Automatic compliance checking against FCA rules with approval workflows.',
    color: 'amber',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#0a0d12" strokeWidth="2" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
  },
  {
    id: 'planning',
    title: 'Planning Tools',
    subtitle: 'Cash Flow & Tax',
    description: 'Lifetime cash flow modelling, tax calculators, and value of advice demonstrations.',
    color: 'pink',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#0a0d12" strokeWidth="2" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
      </svg>
    ),
  },
]

const areaColorClasses: Record<string, { bg: string; gradient: string; text: string; border: string }> = {
  teal: {
    bg: 'bg-gradient-to-br from-accent-teal to-[#0d9488]',
    gradient: 'from-[rgba(20,184,166,0.15)] to-[rgba(20,184,166,0.05)]',
    text: 'text-accent-teal',
    border: 'group-hover:border-accent-teal/20',
  },
  purple: {
    bg: 'bg-gradient-to-br from-[#8b5cf6] to-[#7c3aed]',
    gradient: 'from-[rgba(139,92,246,0.15)] to-[rgba(139,92,246,0.05)]',
    text: 'text-[#8b5cf6]',
    border: 'group-hover:border-[#8b5cf6]/20',
  },
  amber: {
    bg: 'bg-gradient-to-br from-[#f59e0b] to-[#d97706]',
    gradient: 'from-[rgba(245,158,11,0.15)] to-[rgba(245,158,11,0.05)]',
    text: 'text-[#f59e0b]',
    border: 'group-hover:border-[#f59e0b]/20',
  },
  pink: {
    bg: 'bg-gradient-to-br from-[#ec4899] to-[#db2777]',
    gradient: 'from-[rgba(236,72,153,0.15)] to-[rgba(236,72,153,0.05)]',
    text: 'text-[#ec4899]',
    border: 'group-hover:border-[#ec4899]/20',
  },
}

export default function OverviewPage() {
  return (
    <>
      <SEO
        title="WealthSpace Overview | AI Suitability Reports in Minutes"
        description="See how WealthSpace transforms adviser workflows. AI-powered suitability reports, automated compliance checking, and time-saving tools for UK IFAs."
        keywords="AI suitability reports, financial adviser automation, IFA software UK, paraplanning AI, compliance automation, adviser workflow software"
        url="/overview"
      />

      {/* Hero Section */}
      <section className="pt-20 sm:pt-[100px] pb-16 sm:pb-20 px-6 max-w-[1200px] mx-auto relative z-[1]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Hero Text */}
          <div className="max-w-[540px]">
            <div className="inline-flex items-center gap-2.5 border border-accent-teal/30 text-accent-teal py-2.5 px-4 rounded-full text-[13px] font-medium mb-8 bg-accent-teal/5">
              <span className="w-2 h-2 bg-accent-teal rounded-full animate-pulse" />
              AI-powered suitability reports
            </div>
            <h1 className="font-serif text-[40px] sm:text-[52px] lg:text-[60px] font-normal leading-[1.1] tracking-[-0.02em] text-brand-light mb-7">
              Suitability reports
              <br />
              <span className="text-accent-teal">in minutes, not hours</span>
            </h1>
            <p className="text-lg sm:text-[19px] text-brand-muted leading-[1.7] mb-10">
              AI that researches, writes, and checks your suitability reports while you do what you're actually good at: advising clients.
              Built for UK advisers who'd rather not spend evenings wrestling with Word documents.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-5">
              <Button href="/get-started">
                Get Started
                <svg viewBox="0 0 20 20" fill="currentColor" className="w-[18px] h-[18px]">
                  <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                </svg>
              </Button>
            </div>
            <p className="text-sm text-brand-subtle">
              No credit card. No 47-page form. No paraplanner recruitment stress.
            </p>
          </div>

          {/* Hero Visual */}
          <div className="relative order-first lg:order-last">
            <div className="bg-gradient-to-br from-white/[0.04] to-white/[0.01] rounded-2xl border border-white/[0.08] overflow-hidden shadow-[0_40px_80px_rgba(0,0,0,0.4)]">
              {/* Mockup Header */}
              <div className="flex items-center gap-3 p-3.5 bg-white/[0.02] border-b border-white/[0.06]">
                <div className="flex gap-1.5">
                  <span className="w-2.5 h-2.5 rounded-full bg-[#ef4444]" />
                  <span className="w-2.5 h-2.5 rounded-full bg-[#f59e0b]" />
                  <span className="w-2.5 h-2.5 rounded-full bg-[#22c55e]" />
                </div>
                <div className="text-xs text-brand-subtle bg-white/[0.03] py-1 px-3 rounded">
                  app.wealthspace.co.uk
                </div>
              </div>
              {/* Mockup Body */}
              <div className="flex h-[300px]">
                <div className="w-[60px] bg-accent-teal/[0.12] p-3 flex flex-col gap-2.5">
                  <div className="h-9 bg-white/[0.08] rounded-md" />
                  <div className="h-9 bg-white/[0.08] rounded-md" />
                  <div className="h-9 bg-white/[0.08] rounded-md" />
                  <div className="h-9 bg-white/[0.08] rounded-md" />
                </div>
                <div className="flex-1 p-5 grid grid-cols-2 gap-3">
                  <div className="bg-white/[0.03] rounded-lg border border-white/[0.04]" />
                  <div className="bg-white/[0.03] rounded-lg border border-white/[0.04]" />
                  <div className="col-span-2 bg-white/[0.03] rounded-lg border border-white/[0.04]" />
                </div>
              </div>
            </div>

            {/* Floating Card 1 */}
            <div className="absolute top-[30px] right-[-20px] hidden sm:flex items-center gap-2.5 bg-gradient-to-br from-[rgba(30,35,45,0.95)] to-[rgba(20,25,32,0.95)] py-3.5 px-4.5 rounded-xl border border-white/[0.08] shadow-[0_20px_40px_rgba(0,0,0,0.4)] animate-float">
              <div className="w-8 h-8 bg-[rgba(34,197,94,0.15)] rounded-lg flex items-center justify-center">
                <svg viewBox="0 0 20 20" fill="#22c55e" className="w-4 h-4">
                  <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="text-[13px] font-semibold text-brand-light">Suitability report ready</span>
            </div>

            {/* Floating Card 2 */}
            <div className="absolute bottom-[50px] left-[-30px] hidden sm:flex items-center gap-3 bg-gradient-to-br from-[rgba(30,35,45,0.95)] to-[rgba(20,25,32,0.95)] py-4 px-5 rounded-xl border border-white/[0.08] shadow-[0_20px_40px_rgba(0,0,0,0.4)] animate-float-delay">
              <div className="w-10 h-10 bg-gradient-to-br from-accent-teal to-emerald-500 text-brand-dark rounded-[10px] flex items-center justify-center text-sm font-semibold">
                JT
              </div>
              <div>
                <div className="text-sm font-semibold text-brand-light">James Thornton</div>
                <div className="text-xs text-[#2dd4bf]">Report drafted in 8 mins</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Bar */}
      <section className="border-y border-white/[0.06] py-10 text-center relative z-[1]">
        <p className="text-xs text-brand-subtle tracking-[0.1em] font-medium">
          BUILT BY ADVISERS. RUN BY ADVISERS. OWNED BY ADVISERS.
        </p>
      </section>

      {/* Feature Explorer */}
      <section className="py-16 sm:py-[120px] px-6 max-w-[1200px] mx-auto relative z-[1]">
        <div className="text-center mb-12 sm:mb-20">
          <span className="text-xs font-semibold text-accent-teal tracking-[0.15em] mb-5 block">EXPLORE</span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-[48px] font-normal text-brand-light leading-[1.2] tracking-[-0.02em] mb-5">
            Everything you need, in one place
          </h2>
          <p className="text-lg text-brand-muted max-w-[600px] mx-auto leading-[1.7]">
            Click to explore the platform areas that matter most to your practice.
          </p>
        </div>

        {/* Page Selector Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-0 lg:rounded-2xl lg:overflow-hidden lg:border lg:border-white/[0.08]">
          {featureAreas.map((area, index) => {
            const colors = areaColorClasses[area.color]
            return (
              <Link
                key={area.id}
                to={`/features#${area.id}`}
                className={`group relative flex flex-col justify-end min-h-[200px] lg:min-h-[400px] p-6 sm:p-8 rounded-2xl lg:rounded-none transition-all duration-500 hover:flex-[1.5] bg-gradient-to-br ${colors.gradient} border border-white/[0.08] lg:border-0 ${index < 3 ? 'lg:border-r' : ''} ${colors.border}`}
              >
                <div className={`w-12 h-12 rounded-xl ${colors.bg} flex items-center justify-center mb-4 transition-transform duration-400 group-hover:scale-110`}>
                  {area.icon}
                </div>
                <h3 className="font-serif text-xl sm:text-2xl font-semibold text-brand-light mb-2 transition-transform duration-400 group-hover:translate-x-2">
                  {area.title}
                </h3>
                <p className="text-sm text-[#9ca3af] mb-3">{area.subtitle}</p>
                <p className="text-sm text-[#6b7280] leading-relaxed max-w-[280px] opacity-100 lg:opacity-0 lg:translate-y-2.5 transition-all duration-400 lg:group-hover:opacity-100 lg:group-hover:translate-y-0">
                  {area.description}
                </p>
                <div className={`inline-flex items-center gap-2 mt-4 text-sm font-semibold ${colors.text} opacity-100 lg:opacity-0 lg:translate-y-2.5 transition-all duration-400 lg:group-hover:opacity-100 lg:group-hover:translate-y-0`}>
                  Learn more
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </div>
                {/* Accent line */}
                <div className={`absolute bottom-0 left-0 right-0 h-1 ${colors.bg} scale-x-0 origin-left transition-transform duration-500 group-hover:scale-x-100`} />
              </Link>
            )
          })}
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 sm:py-[120px] px-6 max-w-[1200px] mx-auto relative z-[1]">
        <div className="text-center mb-12 sm:mb-20">
          <span className="text-xs font-semibold text-accent-teal tracking-[0.15em] mb-5 block">FEATURES</span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-[48px] font-normal text-brand-light leading-[1.2] tracking-[-0.02em] mb-5">
            AI that actually works for advisers
          </h2>
          <p className="text-lg text-brand-muted max-w-[600px] mx-auto leading-[1.7]">
            Not another chatbot. AI-powered software that helps you deliver better outcomes for your clients.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white/[0.03] to-white/[0.01] border border-white/[0.06] rounded-2xl p-8 sm:p-10 transition-all duration-400 hover:-translate-y-1 hover:border-accent-teal/20 hover:shadow-[0_20px_40px_rgba(0,0,0,0.3)] relative overflow-hidden group"
            >
              <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-accent-teal to-transparent opacity-0 transition-opacity duration-400 group-hover:opacity-100" />
              <div className="w-14 h-14 bg-accent-teal/10 rounded-xl flex items-center justify-center text-accent-teal mb-6">
                {feature.icon}
              </div>
              <h3 className="font-serif text-xl sm:text-[22px] font-medium text-brand-light mb-3 tracking-[-0.01em]">
                {feature.title}
              </h3>
              <p className="text-[15px] text-brand-muted leading-[1.7]">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Adviser Equity Group Section */}
      <section className="py-16 sm:py-[120px] px-6 max-w-[900px] mx-auto text-center relative z-[1]">
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-[48px] font-normal text-brand-light leading-[1.2] tracking-[-0.02em] mb-5">
          The Adviser <span className="text-accent-teal italic">Equity Group</span>
        </h2>
        <p className="text-lg text-brand-muted leading-[1.8] max-w-[700px] mx-auto mb-5">
          WealthSpace isn't just built for advisers - it's owned by them. Our Adviser Equity Group ensures that the people who use our software every day have a real stake in its success and a voice in its future.
        </p>
        <p className="text-lg text-accent-teal italic mb-12">
          Built by Advisers. Run by Advisers. Owned by Advisers.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {[
            { value: 'Real', label: 'Ownership stakes' },
            { value: 'Real', label: 'Voice in direction' },
            { value: 'Real', label: 'Aligned interests' },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="font-serif text-4xl sm:text-[48px] font-light text-accent-teal mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-brand-subtle">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 sm:py-20 px-6 max-w-[900px] mx-auto relative z-[1]">
        <div className="bg-gradient-to-br from-white/[0.03] to-white/[0.01] border border-white/[0.08] rounded-3xl py-12 sm:py-20 px-8 sm:px-[60px] text-center">
          <h2 className="font-serif text-[32px] sm:text-[44px] font-normal text-brand-light tracking-[-0.02em] mb-5">
            Ready to reclaim your evenings?
          </h2>
          <p className="text-lg text-brand-muted leading-[1.7] max-w-[500px] mx-auto mb-10">
            Book a 30-minute demo and see how WealthSpace turns hours of report writing into minutes of review.
            Your backlog will thank you.
          </p>
          <Button href="/get-started" size="lg">
            Book Your Demo
            <svg viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
              <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
            </svg>
          </Button>
          <p className="text-sm text-brand-subtle mt-6">Free. Friendly. Absolutely no obligation.</p>
        </div>
      </section>
    </>
  )
}
